import { render, staticRenderFns } from "./AuditWeight.vue?vue&type=template&id=f48a1090&"
import script from "./AuditWeight.vue?vue&type=script&lang=js&"
export * from "./AuditWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports